import { render, staticRenderFns } from "./IP_ByProjectPrintable.vue?vue&type=template&id=8d5925d2&scoped=true&"
import script from "./IP_ByProjectPrintable.vue?vue&type=script&lang=js&"
export * from "./IP_ByProjectPrintable.vue?vue&type=script&lang=js&"
import style0 from "./IP_ByProjectPrintable.vue?vue&type=style&index=0&id=8d5925d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5925d2",
  null
  
)

export default component.exports